import React, { createContext, useContext } from "react";

const EnvAgnosticFileLookupContext = createContext(false);

/**
 * Enable for test runs: their input data may reference files from either
 * environment, so file pills below look files up sandbox-then-live.
 */
export const EnvAgnosticFileLookupProvider: React.FC<{
  enabled: boolean;
  children: React.ReactNode;
}> = ({ enabled, children }) => (
  <EnvAgnosticFileLookupContext value={enabled}>
    {children}
  </EnvAgnosticFileLookupContext>
);

export const useEnvAgnosticFileLookup = (): boolean =>
  useContext(EnvAgnosticFileLookupContext);
